import { FormInstance } from 'antd/lib/form';
import React from 'react';
import { LabelAndKey } from './types/LabelAndKey';
import GenericSelector from './GenericSelector';

interface Props {
    dependencies?: string[]
    fieldValidator?(rule: any, value: any): Promise<void>
    criterion?: any
    form: FormInstance
}

const TreatmentSelector = ({dependencies, fieldValidator, criterion, form}: Props) => {

    const toLabel = (e: LabelAndKey) => {
        return e.key + ' - ' + e.label
    }

    return <GenericSelector
        fieldId="treatments"
        fieldLabel="Treatment Specialty"
        fieldURL="/mapping?category=tretspef"
        dependencies={dependencies}
        fieldValidator={fieldValidator}
        fieldLabelFunction={toLabel}
        criterion={criterion}
        form={form}
    />
}

export default TreatmentSelector